<template>
    <div
        class="flex w-full gap-16"
        :class="{
            'flex-row': direction === FlexDirection.ROW,
            'flex-col': direction === FlexDirection.COLUMN,
        }"
        :data-component="$options.name"
    >
        <cs-dropdown
            class="w-full text-text-l"
            :modelValue="searchParams.esr.toString()"
            label="Nutzungsart"
            :options="eSRTypeOptions"
            noEmptyOption
            @update:modelValue="onUpdateESRType"
        />
        <cs-dropdown
            class="w-full text-text-l"
            :modelValue="searchParams.etype.toString()"
            label="Immobilientyp"
            :options="estateTypeOptions"
            noEmptyOption
            @update:modelValue="onUpdateEstateType"
        />
    </div>
</template>
<script lang="ts" src="./MsFilterPropertyType.ts" />
